import axios from 'axios';

export const logMailsApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/log-mails`,
    headers: {
        'Content-Type': 'application/json'
    }
})